import { useId, type ReactNode } from 'react';
import s from './Appearance.module.css';
import { useThemePref, type ThemePref } from './theme';

const OPTIONS: { value: ThemePref; label: string; icon: ReactNode }[] = [
  {
    value: 'system',
    label: 'System',
    icon: (
      <>
        <circle cx="12" cy="12" r="8" />
        <path d="M12 4a8 8 0 0 1 0 16Z" fill="currentColor" stroke="none" />
      </>
    ),
  },
  {
    value: 'light',
    label: 'Light',
    icon: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
      </>
    ),
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: <path d="M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10Z" />,
  },
];

/** "Appearance": System / Light / Dark, stored in localStorage['circles.theme'] (lib/theme.ts). */
export function AppearanceControl({ size = 'md', className }: { size?: 'sm' | 'md'; className?: string }) {
  const [pref, setPref] = useThemePref();
  const name = useId();
  return (
    <fieldset className={[s.fieldset, size === 'sm' ? s.sm : '', className].filter(Boolean).join(' ')}>
      <legend className={s.legend}>Appearance</legend>
      <div className={s.track}>
        {OPTIONS.map((o) => (
          <label key={o.value} className={s.option}>
            <input
              className={s.input}
              type="radio"
              name={name}
              value={o.value}
              checked={pref === o.value}
              onChange={() => setPref(o.value)}
            />
            <svg
              className={s.icon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.9"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              {o.icon}
            </svg>
            <span>{o.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
